"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTags = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var react_bootstrap_1 = require("react-bootstrap");
exports.StyledTags = (0, styled_components_1.default)(react_bootstrap_1.Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  padding: 0;\n\n  > span:not(:last-of-type) {\n    margin-right: ", ";\n  }\n"], ["\n  ", "\n  padding: 0;\n\n  > span:not(:last-of-type) {\n    margin-right: ", ";\n  }\n"])), function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('vertical');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
});
var templateObject_1;
